// Static UI translations. Dynamic course/settings content is translated server-side.
export const LANGS = [
  { code: "it", label: "Italiano", flag: "https://flagcdn.com/w40/it.png" },
  { code: "en", label: "English", flag: "https://flagcdn.com/w40/gb.png" },
  { code: "es", label: "Español", flag: "https://flagcdn.com/w40/es.png" },
];

export const translations = {
  it: {
    "nav.courses": "Corsi",
    "nav.talk": "Parla con noi",

    "footer.company_title": "Dati societari",
    "footer.nav_title": "Naviga",
    "footer.all_courses": "Tutti i corsi",
    "footer.reserved": "Area riservata",
    "footer.legal": "Privacy Policy · Cookie Policy",

    "card.countdown_label": "Mancano",
    "card.discover": "Scopri il corso",
    "card.info": "Richiedi informazioni",
    "card.online_badge": "Modulo online",

    "countdown.days": "Giorni",
    "countdown.hours": "Ore",
    "countdown.min": "Min",
    "countdown.sec": "Sec",
    "countdown.started": "Evento iniziato",

    "home.empty_title": "Nessun corso attivo al momento.",
    "home.empty_sub": "Lascia i tuoi dati per essere avvisato sui prossimi corsi.",

    "common.request_info": "Richiedi informazioni",
    "common.enroll_online": "Iscriviti online",
    "common.send_request": "Invia richiesta",

    "lead.course_interest": "Corso di interesse",
    "lead.name": "Nome",
    "lead.surname": "Cognome",
    "lead.email": "Email",
    "lead.phone": "Telefono",
    "lead.city": "Città",
    "lead.profession": "Professione",
    "lead.message": "Messaggio",
    "lead.ph_name": "Il tuo nome",
    "lead.ph_surname": "Il tuo cognome",
    "lead.ph_email": "nome@email.it",
    "lead.ph_phone": "+39 ...",
    "lead.ph_city": "La tua città",
    "lead.ph_profession": "Es. Odontoiatra",
    "lead.ph_message": "Scrivi qui la tua richiesta...",
    "lead.privacy": "Ho letto e accetto l'informativa sulla privacy. *",
    "lead.marketing": "Acconsento a ricevere comunicazioni su prossimi corsi ed eventi (facoltativo).",
    "lead.err_privacy": "Per inviare la richiesta è necessario accettare la privacy policy.",
    "lead.err_generic": "Si è verificato un errore. Riprova tra poco.",
    "lead.success_title": "Grazie!",
    "lead.success_msg": "Abbiamo ricevuto la tua richiesta. Ti ricontatteremo al più presto con tutte le informazioni sul corso.",

    "dialog.info_title": "Richiedi informazioni",
    "dialog.info_sub": "Lascia i tuoi dati: ti invieremo il programma completo e tutte le informazioni.",

    "hero.starts_in": "Il corso inizia tra",
    "hero.fee": "Quota di partecipazione",

    "sticky.date": "Data",
    "sticky.price": "Prezzo",
    "sticky.limited": "Posti limitati",

    "gallery.overline": "Casi clinici · hands-on · aula",
    "gallery.title": "Uno sguardo dentro il corso",

    "video.overline": "Guarda il video",
    "video.title": "Vivi l'atmosfera del corso",

    "benefits.overline": "Perché partecipare",
    "benefits.title": "Un'esperienza formativa concreta",

    "program.overline": "Programma",
    "program.title": "Il percorso, giorno per giorno",
    "program.topics": "Argomenti",
    "program.practice": "Attività pratica",

    "speaker.overline": "Il docente",

    "location.overline": "Location",

    "leadsec.overline": "Parla con noi",
    "leadsec.title": "Richiedi informazioni su questo corso",
    "leadsec.desc": "Compila il modulo: ti ricontatteremo al più presto con tutte le informazioni e il programma completo.",
    "leadsec.point1": "Ricevi il programma completo del corso",
    "leadsec.point2": "Scopri disponibilità e modalità di iscrizione",
    "leadsec.point3": "Parla con il nostro team per ogni informazione",

    "enroll.overline": "Come iscriversi",
    "enroll.title": "Due modalità di iscrizione",
    "enroll.modeA": "Modalità A",
    "enroll.online_title": "Iscrizione online",
    "enroll.online_desc": "Completa l'iscrizione e il pagamento in pochi minuti tramite la nostra piattaforma sicura. Verrai reindirizzato al portale dedicato.",
    "enroll.modeB": "Modalità B",
    "enroll.transfer_title": "Bonifico bancario",
    "enroll.transfer_desc": "È possibile iscriversi anche tramite bonifico bancario.",
    "enroll.holder": "Intestatario",
    "enroll.copy": "Copia IBAN",
    "enroll.copied": "Copiato",
    "enroll.copy_toast": "IBAN copiato negli appunti",
    "enroll.causale1": "Per completare l'iscrizione tramite bonifico, inserire nella causale ",
    "enroll.causale_bold": "nome, cognome e titolo del corso",
    "enroll.causale2": ". Dopo il pagamento, inviare copia del bonifico tramite il modulo informazioni o via email.",

    "faq.overline": "FAQ",
    "faq.title": "Domande frequenti",

    "finalcta.title": "Vuoi ricevere il programma completo o prenotare il tuo posto?",

    "partial.badge": "Disponibile online",
    "partial.fallback_title": "Acquista solo la parte online",
    "partial.price_label": "Prezzo parte online",
    "partial.buy": "Acquista online",
    "partial.secure": "Acquisto su piattaforma esterna sicura",

    "terminated.title": "Questo corso è terminato.",
    "terminated.sub": "Lascia i tuoi dati per ricevere informazioni sui prossimi corsi.",
    "terminated.back": "← Vedi tutti i corsi in programma",

    "notfound.title": "Corso non trovato",
    "notfound.sub": "Il corso che cerchi non è disponibile.",
    "notfound.back": "Torna ai corsi",
  },

  en: {
    "nav.courses": "Courses",
    "nav.talk": "Talk to us",

    "footer.company_title": "Company details",
    "footer.nav_title": "Navigate",
    "footer.all_courses": "All courses",
    "footer.reserved": "Admin area",
    "footer.legal": "Privacy Policy · Cookie Policy",

    "card.countdown_label": "Starts in",
    "card.discover": "Discover the course",
    "card.info": "Request information",
    "card.online_badge": "Online module",

    "countdown.days": "Days",
    "countdown.hours": "Hours",
    "countdown.min": "Min",
    "countdown.sec": "Sec",
    "countdown.started": "Event started",

    "home.empty_title": "No active courses at the moment.",
    "home.empty_sub": "Leave your details to be notified about upcoming courses.",

    "common.request_info": "Request information",
    "common.enroll_online": "Enroll online",
    "common.send_request": "Send request",

    "lead.course_interest": "Course of interest",
    "lead.name": "First name",
    "lead.surname": "Last name",
    "lead.email": "Email",
    "lead.phone": "Phone",
    "lead.city": "City",
    "lead.profession": "Profession",
    "lead.message": "Message",
    "lead.ph_name": "Your first name",
    "lead.ph_surname": "Your last name",
    "lead.ph_email": "name@email.com",
    "lead.ph_phone": "+39 ...",
    "lead.ph_city": "Your city",
    "lead.ph_profession": "E.g. Dentist",
    "lead.ph_message": "Write your request here...",
    "lead.privacy": "I have read and accept the privacy policy. *",
    "lead.marketing": "I agree to receive communications about upcoming courses and events (optional).",
    "lead.err_privacy": "To send the request you must accept the privacy policy.",
    "lead.err_generic": "An error occurred. Please try again shortly.",
    "lead.success_title": "Thank you!",
    "lead.success_msg": "We have received your request. We will get back to you as soon as possible with all the information about the course.",

    "dialog.info_title": "Request information",
    "dialog.info_sub": "Leave your details: we'll send you the full program and all the information.",

    "hero.starts_in": "The course starts in",
    "hero.fee": "Participation fee",

    "sticky.date": "Date",
    "sticky.price": "Price",
    "sticky.limited": "Limited seats",

    "gallery.overline": "Clinical cases · hands-on · classroom",
    "gallery.title": "A look inside the course",

    "video.overline": "Watch the video",
    "video.title": "Experience the course atmosphere",

    "benefits.overline": "Why attend",
    "benefits.title": "A hands-on learning experience",

    "program.overline": "Program",
    "program.title": "The journey, day by day",
    "program.topics": "Topics",
    "program.practice": "Hands-on activity",

    "speaker.overline": "The speaker",

    "location.overline": "Location",

    "leadsec.overline": "Talk to us",
    "leadsec.title": "Request information about this course",
    "leadsec.desc": "Fill out the form: we'll get back to you soon with all the information and the full program.",
    "leadsec.point1": "Get the full course program",
    "leadsec.point2": "Discover availability and enrollment options",
    "leadsec.point3": "Talk to our team for any information",

    "enroll.overline": "How to enroll",
    "enroll.title": "Two ways to enroll",
    "enroll.modeA": "Option A",
    "enroll.online_title": "Online enrollment",
    "enroll.online_desc": "Complete enrollment and payment in a few minutes via our secure platform. You'll be redirected to the dedicated portal.",
    "enroll.modeB": "Option B",
    "enroll.transfer_title": "Bank transfer",
    "enroll.transfer_desc": "You can also enroll via bank transfer.",
    "enroll.holder": "Account holder",
    "enroll.copy": "Copy IBAN",
    "enroll.copied": "Copied",
    "enroll.copy_toast": "IBAN copied to clipboard",
    "enroll.causale1": "To complete enrollment via bank transfer, include in the payment reference ",
    "enroll.causale_bold": "name, surname and course title",
    "enroll.causale2": ". After payment, send a copy of the transfer via the information form or by email.",

    "faq.overline": "FAQ",
    "faq.title": "Frequently asked questions",

    "finalcta.title": "Want to receive the full program or book your seat?",

    "partial.badge": "Available online",
    "partial.fallback_title": "Buy only the online part",
    "partial.price_label": "Online part price",
    "partial.buy": "Buy online",
    "partial.secure": "Purchase on a secure external platform",

    "terminated.title": "This course has ended.",
    "terminated.sub": "Leave your details to receive information about upcoming courses.",
    "terminated.back": "← See all upcoming courses",

    "notfound.title": "Course not found",
    "notfound.sub": "The course you're looking for is not available.",
    "notfound.back": "Back to courses",
  },

  es: {
    "nav.courses": "Cursos",
    "nav.talk": "Habla con nosotros",

    "footer.company_title": "Datos de la empresa",
    "footer.nav_title": "Navegación",
    "footer.all_courses": "Todos los cursos",
    "footer.reserved": "Área reservada",
    "footer.legal": "Política de privacidad · Cookies",

    "card.countdown_label": "Faltan",
    "card.discover": "Descubre el curso",
    "card.info": "Solicita información",
    "card.online_badge": "Módulo online",

    "countdown.days": "Días",
    "countdown.hours": "Horas",
    "countdown.min": "Min",
    "countdown.sec": "Seg",
    "countdown.started": "Evento iniciado",

    "home.empty_title": "No hay cursos activos en este momento.",
    "home.empty_sub": "Déjanos tus datos para recibir información sobre próximos cursos.",

    "common.request_info": "Solicita información",
    "common.enroll_online": "Inscríbete online",
    "common.send_request": "Enviar solicitud",

    "lead.course_interest": "Curso de interés",
    "lead.name": "Nombre",
    "lead.surname": "Apellido",
    "lead.email": "Email",
    "lead.phone": "Teléfono",
    "lead.city": "Ciudad",
    "lead.profession": "Profesión",
    "lead.message": "Mensaje",
    "lead.ph_name": "Tu nombre",
    "lead.ph_surname": "Tu apellido",
    "lead.ph_email": "nombre@email.com",
    "lead.ph_phone": "+34 ...",
    "lead.ph_city": "Tu ciudad",
    "lead.ph_profession": "Ej. Odontólogo",
    "lead.ph_message": "Escribe aquí tu solicitud...",
    "lead.privacy": "He leído y acepto la política de privacidad. *",
    "lead.marketing": "Acepto recibir comunicaciones sobre próximos cursos y eventos (opcional).",
    "lead.err_privacy": "Para enviar la solicitud debes aceptar la política de privacidad.",
    "lead.err_generic": "Se ha producido un error. Inténtalo de nuevo en breve.",
    "lead.success_title": "¡Gracias!",
    "lead.success_msg": "Hemos recibido tu solicitud. Te contactaremos lo antes posible con toda la información sobre el curso.",

    "dialog.info_title": "Solicita información",
    "dialog.info_sub": "Déjanos tus datos: te enviaremos el programa completo y toda la información.",

    "hero.starts_in": "El curso empieza en",
    "hero.fee": "Cuota de participación",

    "sticky.date": "Fecha",
    "sticky.price": "Precio",
    "sticky.limited": "Plazas limitadas",

    "gallery.overline": "Casos clínicos · práctica · aula",
    "gallery.title": "Una mirada dentro del curso",

    "video.overline": "Mira el vídeo",
    "video.title": "Vive la atmósfera del curso",

    "benefits.overline": "Por qué participar",
    "benefits.title": "Una experiencia formativa concreta",

    "program.overline": "Programa",
    "program.title": "El recorrido, día a día",
    "program.topics": "Temas",
    "program.practice": "Actividad práctica",

    "speaker.overline": "El ponente",

    "location.overline": "Ubicación",

    "leadsec.overline": "Habla con nosotros",
    "leadsec.title": "Solicita información sobre este curso",
    "leadsec.desc": "Rellena el formulario: te contactaremos pronto con toda la información y el programa completo.",
    "leadsec.point1": "Recibe el programa completo del curso",
    "leadsec.point2": "Descubre disponibilidad y opciones de inscripción",
    "leadsec.point3": "Habla con nuestro equipo para cualquier información",

    "enroll.overline": "Cómo inscribirse",
    "enroll.title": "Dos formas de inscripción",
    "enroll.modeA": "Modalidad A",
    "enroll.online_title": "Inscripción online",
    "enroll.online_desc": "Completa la inscripción y el pago en pocos minutos a través de nuestra plataforma segura. Serás redirigido al portal dedicado.",
    "enroll.modeB": "Modalidad B",
    "enroll.transfer_title": "Transferencia bancaria",
    "enroll.transfer_desc": "También puedes inscribirte mediante transferencia bancaria.",
    "enroll.holder": "Titular",
    "enroll.copy": "Copiar IBAN",
    "enroll.copied": "Copiado",
    "enroll.copy_toast": "IBAN copiado al portapapeles",
    "enroll.causale1": "Para completar la inscripción mediante transferencia, indica en el concepto ",
    "enroll.causale_bold": "nombre, apellido y título del curso",
    "enroll.causale2": ". Tras el pago, envía una copia de la transferencia mediante el formulario de información o por email.",

    "faq.overline": "FAQ",
    "faq.title": "Preguntas frecuentes",

    "finalcta.title": "¿Quieres recibir el programa completo o reservar tu plaza?",

    "partial.badge": "Disponible online",
    "partial.fallback_title": "Compra solo la parte online",
    "partial.price_label": "Precio parte online",
    "partial.buy": "Comprar online",
    "partial.secure": "Compra en plataforma externa segura",

    "terminated.title": "Este curso ha finalizado.",
    "terminated.sub": "Déjanos tus datos para recibir información sobre próximos cursos.",
    "terminated.back": "← Ver todos los cursos programados",

    "notfound.title": "Curso no encontrado",
    "notfound.sub": "El curso que buscas no está disponible.",
    "notfound.back": "Volver a los cursos",
  },
};
